module.exports = __webpack_public_path__ + "img/svg/background-messages-stain.81b5b126eaf1d37640ce16afbbca2412.svg";